import styled, { css } from 'styled-components';
import { Container as InputContainer } from 'components/Input/styles';
import { Container as ButtonGroup } from 'components/ButtonGroup/styles';
import { Form as FormBase } from '@unform/web';
import {
  VerticalTimeline as VerticalTimelineBase,
  VerticalTimelineElement as VerticalTimelineElementBase,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { readableColor } from 'polished';
import { device, size } from 'styles/device';

interface IVerticalTimelineBase {
  children: React.ReactNode;
  layout: '2-columns' | '1-column';
}

export const VerticalTimeline = styled(VerticalTimelineBase)<
  IVerticalTimelineBase
>`
  width: 100% !important;
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden !important;
  flex: 1;
  /* padding: 0 !important; */
  margin: 0;
  @media ${device.laptopM} {
    padding: 0 0.45em !important;
  }

  &::before {
    background: ${props => props.theme.timeline.bar} !important;
    @media ${device.laptopM} {
      left: 24.5px !important;
    }

    ${props =>
      props.layout === '1-column' &&
      css`
        left: 26.5px !important;
        width: 3px !important;
      `}
  }
`;

interface IVerticalTimelineElementBase {
  children: React.ReactNode;
  layout: '2-columns' | '1-column';
}

export const VerticalTimelineElement = styled(VerticalTimelineElementBase)<
  IVerticalTimelineElementBase
>`
  /* margin: 2em 0 !important !important; */
  @media only screen and (min-width: ${size.laptopM}) {
    margin: 1em 0 !important;
  }
  p {
    margin-top: 0.5em !important;
    @media ${device.laptopM} {
      margin: 0 !important;
      font-size: calc(0.23vw + 0.8125rem) !important;
    }
  }
  span {
    padding: 0.8em 0.8em !important;
    @media ${device.laptopM} {
      padding: 0 !important;
    }
  }

  .vertical-timeline-element-content-arrow {
    top: 15px !important;
  }

  ${props =>
    props.layout === '1-column' &&
    css`
      .vertical-timeline-element-icon {
        width: 36px !important;
        height: 36px !important;
        margin-left: 10px !important;

        .sb-avatar {
          display: inline-block;
          position: absolute;
          /* vertical-align: middle; */
          top: 0;
          left: 0;

          .sb-avatar__image {
            width: 36px !important;
            height: 36px !important;
          }
        }
      }

      .vertical-timeline-element-date {
        display: none !important;
      }
    `}
  ${props =>
    props.layout === '2-columns' &&
    css`
      .vertical-timeline-element-icon {
        width: 45px !important;
        height: 45px !important;
        left: 50% !important;
        margin-left: -22.5px !important;

        .sb-avatar {
          display: inline-block;
          position: absolute;
          /* vertical-align: middle; */
          top: 0;
          left: 0;
          .sb-avatar__image {
            max-width: 45px !important;
            width: 45px !important;
            height: 45px !important;
          }
        }

        @media ${device.laptopM} {
          position: absolute;
          margin-left: 0 !important;
          top: 0 !important;
          left: 0 !important;
          width: 40px !important;
          height: 40px !important;
        }
        svg {
          width: 22px;
          height: 22px;
        }
      }

      .vertical-timeline-element-date {
        padding: 0 !important;
        font-size: 0.775rem !important;
        font-style: italic !important;
      }
    `}
`;

export const VerticalTimelineContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  div {
    flex-direction: column;
    span {
      font-size: 0.775rem;
      opacity: 0.7;
      padding: 0 !important;
      margin-right: 5px;
    }
    strong {
      font-size: 12px;
      opacity: 0.7;
      font-weight: normal;
      font-style: italic;
      padding: 0 !important;
    }
  }
  button {
    opacity: 0.8 !important;
  }
`;

export const FormMessage = styled(FormBase)`
  height: 60px;
  display: flex;
  /* padding: 15px 5px 15px 0; */
  align-items: center;
  ${InputContainer} {
    height: 40px !important;
    max-height: 40px !important;
    width: 100%;
  }

  button {
    margin-left: 5px;
  }
`;

interface AvatarContentProps {
  setor:
    | 'programacao'
    | 'jornalismo'
    | 'cedoc'
    | 'opec'
    | 'promo'
    | 'hub'
    | 'marketing'
    | 'engenharia';
}
export const AvatarContent = styled.div<Omit<AvatarContentProps, 'theme'>>`
  span {
    position: absolute;
    display: inline-block;
    z-index: 8;

    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2px 8px !important;
    line-height: normal;
    margin: 0 !important;
    border-radius: 10px;
    font-weight: bold;
    color: ${props =>
      readableColor(props.theme.flag[props.setor], '#f2f2f2', '#3b3b3b')};
    background: ${props => props.theme.flag[props.setor]};
  }
`;

interface IScrollProps {
  height?: string;
  width?: string;
  padding?: string;
}

export const Scroll = styled(PerfectScrollbar)<IScrollProps>`
  height: ${props =>
    props.height ? props.height : 'calc(100vh - 220px)'} !important;
  width: ${props => (props.width ? props.width : '100%')};
  padding: ${props => (props.padding ? props.padding : '0 15px')};
  position: relative;
  ${ButtonGroup} {
    position: sticky;
    top: 0;
    left: 100%;
    right: 0;
    width: fit-content;
    transform: scale(0.9);
    z-index: 8 !important;
  }
`;
